import { $, $$, isMobile } from '@utils';

function init() {
  if (!$('[data-au-table-search]')) return;

  addEventListeners();
}

function addEventListeners() {
  isMobile.addEventListener('change', () => {
    if (isMobile.matches) {
      tableMultiSearchBarSticky();
    }
  });

  if (isMobile.matches) {
    tableMultiSearchBarSticky();
  }

  tableCheckBoxSelection();
}

/**
 *  Function to set sticky position of multisearchbar and show it or hide it
 * depending on scroll up or down
 */
function tableMultiSearchBarSticky() {
  let lastScrollTop = 0;
  const multiSearchBar = $('[data-au-search-table-multisearch-bar]');
  if (!multiSearchBar) return;
  const multiSearchBarTop = parseInt(multiSearchBar.getBoundingClientRect().top + window.scrollY, 10);
  const headerHeight = $('header > div') ? $('header > div').offsetHeight + 8 : 54;

  // set sticky top position of multisearch bar
  multiSearchBar.style.top = `${headerHeight}px`;

  // show or hide multisearchbar when scroll down and if scrolltop is higher than offset top of multisearch bar
  window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop && scrollTop >= multiSearchBarTop - headerHeight) {
      // Scroll down
      multiSearchBar.classList.add('au-news__multisearch--hide');
    } else {
      // Scroll up
      multiSearchBar.classList.remove('au-news__multisearch--hide');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // To avoid negative values on iOS
  });
}

function tableCheckBoxSelection() {
  const headerCheckbox = $('[data-au-content-table-th-checkbox]');
  if (!headerCheckbox) return;
  const rowCheckboxes = $$('[data-au-content-table-td-checkbox]');

  function updateHeaderCheckbox() {
    const checkedCount = [...rowCheckboxes].filter((checkbox) => checkbox.checked).length;
    const totalCount = rowCheckboxes.length;

    if (checkedCount === 0) {
      headerCheckbox.checked = false;
      headerCheckbox.indeterminate = false;
    } else if (checkedCount === totalCount) {
      headerCheckbox.checked = true;
      headerCheckbox.indeterminate = false;
    } else {
      headerCheckbox.checked = false;
      headerCheckbox.indeterminate = true;
    }
  }

  // Add event listener to all row checkboxes
  rowCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateHeaderCheckbox);
  });

  // Add functionality to header checkbox (toggle all checkboxes)
  headerCheckbox.addEventListener('change', function () {
    const isChecked = headerCheckbox.checked;
    rowCheckboxes.forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
    updateHeaderCheckbox();
  });
}

export default { init };
